import React from "react";

/* Folk-art details from the original La Muerte theme. All icons are decorative. */

const GOLD = "var(--marigold)";
const PALE_GOLD = "var(--agua)";
const ROSE = "var(--rosa)";
const DANGER = "#e5645a";
const WARN = "#e8b35c";
const STROKE = 2;

/** The sugar skull from main, with the shared theme's accent colours. */
export const BrandMark = (props) => (
  <svg viewBox="0 0 40 44" aria-hidden="true" {...props}>
    <path d="M20 2C9 2 3 10 3 19c0 6 3 10 6 13v9h22v-9c3-3 6-7 6-13C37 10 31 2 20 2z" fill="var(--bone)" />
    <circle cx="13" cy="20" r="5" fill={ROSE} />
    <circle cx="27" cy="20" r="5" fill={PALE_GOLD} />
    <circle cx="13" cy="20" r="2" fill="var(--night)" />
    <circle cx="27" cy="20" r="2" fill="var(--night)" />
    <path d="M20 25l-3 5h6z" fill={GOLD} />
    <path d="M13 36v5M17 36v5M23 36v5M27 36v5" stroke="var(--night)" strokeWidth="1.6" />
    <path d="M20 5l1.5 3 3 .3-2.2 2 .6 3-2.9-1.6L17.1 13l.6-3-2.2-2 3-.3z" fill={GOLD} />
  </svg>
);

export const Marigold = (props) => (
  <svg viewBox="0 0 80 80" fill="none" aria-hidden="true" {...props}>
    {Array.from({ length: 12 }, (_, i) => (
      <ellipse key={i} cx="40" cy="23" rx="9" ry="20" fill="currentColor" opacity={i % 2 ? 0.72 : 1} transform={`rotate(${i * 30} 40 40)`} />
    ))}
    <circle cx="40" cy="40" r="14" fill="var(--marigold-deep)" />
    <circle cx="40" cy="40" r="8" fill="var(--glow)" />
    <circle cx="40" cy="40" r="3" fill="var(--marigold-deep)" />
  </svg>
);

export const ArrowIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path d="M4 12h15m-6-6 6 6-6 6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ClockIcon = (props) => (
  <svg viewBox="0 0 44 44" fill="none" aria-hidden="true" {...props}>
    <circle cx="22" cy="22" r="18" stroke={GOLD} strokeWidth={STROKE} />
    <path d="M22 12v10l7 5" stroke={PALE_GOLD} strokeWidth={STROKE} strokeLinecap="round" />
  </svg>
);

export const PinIcon = (props) => (
  <svg viewBox="0 0 44 44" fill="none" aria-hidden="true" {...props}>
    <path d="M22 40s-14-13-14-22a14 14 0 0128 0c0 9-14 22-14 22z" stroke={GOLD} strokeWidth={STROKE} />
    <circle cx="22" cy="18" r="5" fill={ROSE} />
  </svg>
);

export const TicketIcon = (props) => (
  <svg viewBox="0 0 44 44" fill="none" aria-hidden="true" {...props}>
    <rect x="5" y="12" width="34" height="20" rx="4" stroke={GOLD} strokeWidth={STROKE} />
    <path d="M16 12v20M28 12v20" stroke={PALE_GOLD} strokeWidth={STROKE} strokeDasharray="3 3" />
  </svg>
);

export const PathIcon = (props) => (
  <svg viewBox="0 0 52 52" fill="none" aria-hidden="true" {...props}>
    <path d="M8 44c6-14 10-24 18-34 8 10 12 20 18 34" stroke={GOLD} strokeWidth={STROKE} strokeLinecap="round" />
    <path d="M14 44h24" stroke={ROSE} strokeWidth={STROKE} strokeLinecap="round" />
    <circle cx="26" cy="12" r="4" fill={PALE_GOLD} />
  </svg>
);

export const AltarIcon = (props) => (
  <svg viewBox="0 0 52 52" fill="none" aria-hidden="true" {...props}>
    <path d="M10 44V22l16-12 16 12v22z" stroke={GOLD} strokeWidth={STROKE} strokeLinejoin="round" />
    <path d="M22 44V32h8v12" stroke={ROSE} strokeWidth={STROKE} />
    <circle cx="26" cy="24" r="3" fill={PALE_GOLD} />
  </svg>
);

export const ChamberIcon = (props) => (
  <svg viewBox="0 0 52 52" fill="none" aria-hidden="true" {...props}>
    <rect x="10" y="10" width="32" height="32" rx="3" stroke={GOLD} strokeWidth={STROKE} />
    <path d="M18 26h16M26 18v16" stroke={PALE_GOLD} strokeWidth={STROKE} strokeLinecap="round" />
    <circle cx="26" cy="26" r="3" fill={ROSE} />
  </svg>
);

export const WarnIcon = (props) => (
  <svg viewBox="0 0 36 36" fill="none" aria-hidden="true" {...props}>
    <path d="M18 4l16 28H2z" stroke={DANGER} strokeWidth={STROKE} strokeLinejoin="round" />
    <path d="M18 14v8" stroke={DANGER} strokeWidth={STROKE} strokeLinecap="round" />
    <circle cx="18" cy="27" r="1.8" fill={DANGER} />
  </svg>
);

export const LockIcon = (props) => (
  <svg viewBox="0 0 36 36" fill="none" aria-hidden="true" {...props}>
    <rect x="6" y="15" width="24" height="17" rx="3" stroke={WARN} strokeWidth={STROKE} />
    <path d="M11 15v-4a7 7 0 0114 0v4" stroke={WARN} strokeWidth={STROKE} />
  </svg>
);

export const CloseIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
  </svg>
);

export const PauseIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path d="M9 6v12M15 6v12" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

export const PlayIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path d="m9 6 9 6-9 6V6Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>
);

const ACTIVITY_ICONS = { stezka: PathIcon, ofrenda: AltarIcon, komnata: ChamberIcon };

/** Icon for an activity key ("stezka" | "ofrenda" | "komnata"). */
export const ActivityIcon = ({ activityKey, ...props }) => {
  const Icon = ACTIVITY_ICONS[activityKey] ?? PathIcon;
  return <Icon {...props} />;
};
